module.exports = __webpack_public_path__ + "img/biglogo.24975923.png";